import { Component } from '@angular/core';

@Component({
    selector: 'app-online',
    templateUrl: './online.component.html'
})
export class OnlineComponent {
}
